import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';

import authReducer, {
  updateAccessToken,
  logout,
} from './features/auth/authSlice';

import languageReducer from './features/language/languageSlice';

import actionCountsReducer from './features/actionCounts/actionCountsSlice';

import {
  setAuthHandlers,
} from './api/axios.js';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    language: languageReducer,

    actionCounts: actionCountsReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

setAuthHandlers({
  getToken: () =>
    store.getState()?.auth?.accessToken,

  onRefreshSuccess: (token) => {
    store.dispatch(
      updateAccessToken(token)
    );
  },

  onForceLogout: () => {
    store.dispatch(logout());

    window.location.assign('/login');
  },
});

export default store;